import { Component, ViewChild, Output, EventEmitter } from '@angular/core';

import { HisAuthService, HisSearchFormComponent } from 'hisng';

import { SEARCH_CONFIG_PUBLICATION_ORCID_USER } from 'app/fs/res/common/model/searchConstants';

@Component( {
    selector: 'res-publication-search-orcid-user-form',
    templateUrl: './publication-search-orcid-user-form.component.html',
} )
export class PublicationSearchOrcidUserFormComponent {
    @ViewChild( HisSearchFormComponent, { static: true } ) searchFormComponent: HisSearchFormComponent;
    @Output() submitSearch = new EventEmitter();

    readonly SEARCH_CONFIG_PUBLICATION_ORCID_USER = SEARCH_CONFIG_PUBLICATION_ORCID_USER;

    constructor( public auth: HisAuthService ) {}

    public onSubmitSearch( search: any ) {
        this.submitSearch.emit(search);
    }

    public resetInputs() {
        this.searchFormComponent.resetInputs();
    }
}
